import sectionsSlice from './sectionsSlice';

export * from './thunks';

export default sectionsSlice;
